"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = __importDefault(require("dayjs"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(utc_1.default);
var transformUnavailableRange = function (data) {
    return {
        start_date: dayjs_1.default(data.startDate).utc(true).toISOString(),
        end_date: dayjs_1.default(data.endDate).utc(true).toISOString(),
    };
};
exports.default = transformUnavailableRange;
